module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('img', {
    staticClass: "card-img-top",
    attrs: {
      "src": _vm.image,
      "alt": _vm.name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v("QTY: " + _vm._s(_vm.getItemSupply(_vm.invId)) + ", " + _vm._s(_vm._f("dollars")(_vm.price)))]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-end"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a0ed101"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 334
// module chunks = 0